import faqMeta from './faqMeta.json';

// Bumped automatically by scripts/syncFaqDate.js whenever the faqs below change.
export const faqUpdatedOn = faqMeta.updatedOn;

export const faqs = [
  {
    q: 'What is this app all about?',
    a: 'FamConnect is designed to help family members stay connected, ensuring everyone remains up to date with relevant information. The app builds upon collected data to maintain accurate and current data, keeping the family tree current. This web app will allow users to create events and use text messaging to connect with various family members, individually or as a group.',
  },
  {
    q: 'Who is the Target audience for this family web application?',
    a: [
      'The target audience for this web app are administrators who oversee and maintain family data, coordinate with event planners, and preserves any family history obtained from various sources in the family.',
      [
        'The family app gives administrators one secure, accessible place to organize family information, coordinate gatherings, connect relatives, and preserve the family\u2019s legacy; once information is entered, relatives can access ',
        {
          text: 'various parts of the app to view pertinent data points, create upcoming invitational events, text message with family, use the forms tab to enter new data for the family tree and many more exciting features to come.',
          bold: true,
        },
      ],
      [{ text: 'Key Benefits', bold: 'heavy' }],
      ['\u2022 ', { text: 'Centralized management:', bold: true }, ' Keeps family information and updates in one place.'],
      ['\u2022 ', { text: 'Simpler coordination:', bold: true }, ' Makes planning gatherings and sharing information easier.'],
      ['\u2022 ', { text: 'Stronger connections:', bold: true }, ' Helps relatives stay informed and engaged.'],
      ['\u2022 ', { text: 'Legacy preservation:', bold: true }, ' Supports the long-term preservation of family history and memories.'],
    ],
    spacedParagraphs: true,
  },
  {
    q: 'What are the benefits of such an app?',
    a: 'The benefits of the FamConnect web app are to bring families together on one platform, enable families to share news in the family, foster stronger connections, and provide a reliable platform for maintaining essential family data. Staying connected long term and staying current with most events will keep everyone in the loop. This will create a sense of pride among family members.',
  },
  {
    q: 'What is the significance of using colors for each family line?',
    a: 'The significance of assigning a unique color to each family line allows users to quickly identify their relatives by their assigned line color and head of that line. Establishing the start/top of the line will help family members follow the branches that help make up the family tree. This visual distinction can make the family tree easier to navigate and reduce any confusion when connecting family members to their respective family lines/colors, especially using the unique color system.',
  },
  {
    q: 'Can the app handle previous generations?',
    a: 'Yes, the app can handle previous generations, but it is recommended that the user stay within the parameters of not more than 5-7 generations, as this web app is not based on prior historical lineage, but staying connected with more recent living relatives. By putting a starting point of grandparents, it gives historical value and helps to start the process of developing a family tree that covers all the generations that come after the start or top of the line. It also focuses on living relatives, which help in fostering connections within each family line.',
  },
  {
    q: 'Why do family members pay a fee?',
    a: 'The annual household fee of $35 supports the development of new application features, the provision of ongoing technical assistance, and the delivery of regular updates, thereby ensuring a reliable and engaging online experience for all users.',
  },
  {
    q: 'What is included with the household yearly fee for the user?',
    a: 'Included with the household yearly fee is, access to the app any time, the ability to communicate with your family in a private environment, ability to create invitations, view accurate and real-time family data, and get the latest family news. Anyone can submit family news to be shared with their family line or the entire family at any time without restrictions.',
  },
  {
    q: 'How can I share this app with other families?',
    a: 'Sharing this app with other families is very important to the overall success of such a needed app.  Since this is a web app, you can copy the link and share it with other family members, friends, etc. who are admins for their family.  They can begin the process of connecting with their family in a more efficient and private environment. Once they sign up and choose a plan, they can start gathering their family data and watch how the app automates reports and works with the other features on the left panel.',
  },
  {
    q: 'How often will upgrades take place?',
    a: 'FamConnect26 recognizes that technology is always advancing, so to ensure the app stays current with new developments and continues to provide users with optimal functionality, upgrades will be scheduled on a regular or annual basis. This approach allows FamConnect26 to incorporate the latest features and improvements, maintaining a reliable and up-to-date platform for families to continue staying connected.',
  },
  {
    q: 'What is the recommended browser and device to use?',
    a: [
      'The recommended browsers are Google Chrome, Firefox, or Safari.',
      'For now, it is highly recommended that family admins who wish to import or manually add family data, use a laptop or desktop computer along with an additional monitor, as this will give maximum flexibility in using the app.',
    ],
    spacedParagraphs: true,
  },
  {
    q: 'Can data be imported to the web application? If so, what type of files can be imported?',
    a: [
      'Yes, data can be imported to the web application using Excel or a CSV file.',
      [{ text: 'Instructions for admins only:', bold: true }],
      'It is recommended that the heads of each line (children of the top of the line) be added to the family tree first before proceeding to the import feature, as this will allow the heads to be picked from the list before data can be imported.',
      'It is also recommended, that one line at a time be added to the family tree so it can be checked for accuracy before proceeding to the next line.',
    ],
    spacedParagraphs: true,
  },
  {
    q: 'Will users be allowed to recommend new ideas for the app?',
    a: 'Yes, users are encouraged to submit ideas that can help enhance the app experience, by sending a message through text messaging or by using the contact admin button at the top of the screen.',
  },
  {
    q: 'What information will be collected in this web app, and will this data be protected?',
    a: [
      'General information like names, marital status, email addresses, mobile numbers, etc. will be collected but no mailing addresses will be used in this app--as it is not necessary. The admin will be the only one who will have access to this data and will keep the info updated with the help of family members’ participation in submitting new information to their line representative.',
      'Yes, the data will be protected using the latest technology.',
    ],
    spacedParagraphs: true,
  },
  {
    q: 'If a family member wishes to add the other side of their family to the app, what is the process?',
    a: [
      [
        'To add the other side of a family, the user will have to sign up with a different email address and sign up as ',
        { text: 'an Admin', to: '/register' },
        '.',
      ],
      [
        'The other option is to ',
        { text: 'find an Admin', to: '/login' },
        ' for the other side of the family and have them sign up. Once they add the other side with your name and email address, you will see the other side noted in the family side dropdown, at the top right of the screen.',
      ],
      'The admin must add the start/top of the line (grandparents) and at least one of the children to access the instructions under the import tab, which will help in setting up the rest of the family members in the family tree/chart.',
    ],
    spacedParagraphs: true,
  },
];

/**
 * An answer (`a`) is a paragraph, or a list of paragraphs.
 * A paragraph is a plain string, or a list of parts where a part is a plain
 * string, `{ text, to }` for an inline link to an in-app route, or
 * `{ text, bold }` for emphasis -- `true` for a light bold, `'heavy'` for a
 * heavier one.
 */

export function getFaqAnswerParagraphs(item) {
  if (!Array.isArray(item.a)) return [item.a];
  // A single paragraph carrying inline links holds link objects directly.
  const holdsLinkParts = item.a.some(
    (part) => part && typeof part === 'object' && !Array.isArray(part)
  );
  return holdsLinkParts ? [item.a] : item.a;
}

export function getFaqParagraphParts(paragraph) {
  return Array.isArray(paragraph) ? paragraph : [paragraph];
}
